import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/SideNavBar/SideNavBar';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import GroupIcon from '@mui/icons-material/Group';
import { useAuth } from '../../contexts/AuthContext';

const baseUserMenu = [
    { text: 'Orders', icon: <ShoppingCartIcon />, path: '/user-portal' },
    { text: 'My Profile', icon: <AssignmentIndIcon />, path: '/user-profile' },
];

const UserPortalSideBar = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    const menuItemsWithNavigation = useMemo(() => {
        const items = [...baseUserMenu];
        if (user?.is_business_primary) {
            items.push({
                text: 'Manage users',
                icon: <GroupIcon />,
                path: '/user-business-users',
            });
        }
        return items.map((item) => ({
            ...item,
            onClick: () => navigate(item.path),
        }));
    }, [navigate, user?.is_business_primary]);

    return <Sidebar menuItems={menuItemsWithNavigation} />;
};

export default UserPortalSideBar;

